<template>
    <div>
        <div class="container-fluid p-0">
            <card>
                <template slot="header">
                    <h4>وضعیت حساب ها</h4>
                    <hr />
                </template>
                <template slot="content">
                    <div class="row">
                    <div class="col-lg-4 col-6">
                        <div class="row">
                        <div class="col-12">
                            <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-radio-group id="btn-radios-3" @change="SelectDate" v-model="selected" :options="['امروز', 'ماه جاری', 'امسال']" :aria-describedby="ariaDescribedby" name="radio-btn-stacked" buttons stacked></b-form-radio-group>
                            </b-form-group>
                            <SearchableCombo
                            v-if="$store.state.renderComponentCombo"
                            :edit="false"
                            :grp="29"
                            :code="null"
                            @ResultCombo="GetResultBank"
                            :rownumintable="3"
                            :defaultvalue="'XXX'"
                            :action="'TblCrmCombo/GetComboById'"
                            :method="'POST'"
                            :idinput="'Grp'"
                            :keyItem="'Grp'"
                            :disabled="false"
                            :ClassProps="'required'"
                            :defaultFirst="false"
                            :SelectAll="true"
                            >
                            </SearchableCombo>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-8 text-center">
                        <div v-if="chartDepositStatus.length < 1" class="w-100">
                            <h5>در این بازه واریزی ثبت نشده است</h5>
                            </div>
                            <apexchart v-if="render" height="350" :options="ApexChartOptions" :series="ApexChartOptions.series"></apexchart>
                    </div>
                    <div class="col-12 pt-6">
                        <div class="row">
                        <div class="col-md-6 col-12">
                            <span class="text-success" style="font-size: 0.6rem">  تعداد کل تراکنش ها :
                                 <h6>{{ DepositCoutnt == null ? 0 : DepositCoutnt }}</h6>
                            </span>
                        </div>
                        <div class="col-md-6 col-12">
                            <span class="text-success" style="font-size: 0.6rem">  مجموع کل تراکنش ها :
                                 <h6>{{ DepositSum == null ? 0 : $Comma3ragham(DepositSum)  }}</h6>
                            </span>
                        </div>
                        </div>
                    </div>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  components: { Card,SearchableCombo },
    data (){
        return {
            DepositCoutnt:0,
            DepositSum:0,
            selected: 'امروز',
            bankId:null,
            chartDepositStatus :[],
            render: true,
      ApexChartOptions: {
        chart: {
          type: 'pie',
        },
        dataLabels: {
			enabled: false
		},
        series: [],
        xaxis: {
            type: ''
        },
        labels: [],
        stroke: {
          show: false,
        },
      },
        }
    },
    methods:{
        GetResultBank(data) {
        if (data.id != null) {
            this.bankId = data.id
            if (data.id == 'XXX') {
                this.bankId = null
        }
        this.getData(this.selector)
        }

        },
        SelectDate() {
            if (this.selected == 'امروز') this.selector = 1
            else if (this.selected == 'ماه جاری') this.selector = 2
            else if (this.selected == 'امسال') this.selector = 3
            this.getData(this.selector)
        },
        getData(selector){
            // console.log(selector);
            var DataAxios = { Method: 'POST', Action: 'DashboardSales/ChartDeposit', ArryfildValue: { Id: selector==undefined?1:selector, Usergrp: this.bankId } }
            this.$PostData(DataAxios)
                .then((result) => {
                    // console.log(result);
                    this.chartDepositStatus = result.chartDepositStatus
                    this.DepositCoutnt = 0
                    this.DepositSum=0
                    this.chartDepositStatus.forEach((element) => {
                        this.DepositCoutnt += element.countDeposit
                        this.DepositSum += element.amount
                    })
                }).finally(()=>{
                    this.render = false
                    if (this.chartDepositStatus.length > 0) {
                        this.ApexChartOptions.series = []
                        this.ApexChartOptions.labels = []
                        this.chartDepositStatus.forEach((element) => {
                        this.ApexChartOptions.labels.push(element.bnkName)
                        
                        this.ApexChartOptions.series.push(element.amount)
                        // console.log('element.amount:' ,this.ApexChartOptions.series);
                        this.$nextTick(() => {
                            this.render = true
                            this.render = true
                        })
                        })
                    }
                })
        }
    },
    // beforeMount(){
    //     this.getData(this.selector)
    // }
}
</script>
<style scoped>

</style>